export default __webpack_public_path__ + "static/media/danceFloor.0214591c.jpg";